/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protein_Meals_Zero_To_OneInputs */

const en_us2_protein_meals_zero_to_one = /** @type {(inputs: Protein_Meals_Zero_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0–1`)
};

const pt_br2_protein_meals_zero_to_one = /** @type {(inputs: Protein_Meals_Zero_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma ou uma`)
};

const es_419_protein_meals_zero_to_one = /** @type {(inputs: Protein_Meals_Zero_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0–1`)
};

const pt_pt2_protein_meals_zero_to_one = /** @type {(inputs: Protein_Meals_Zero_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma ou uma`)
};

const fr_fr2_protein_meals_zero_to_one = /** @type {(inputs: Protein_Meals_Zero_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0–1`)
};

const de_de2_protein_meals_zero_to_one = /** @type {(inputs: Protein_Meals_Zero_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine oder eine`)
};

const it_it2_protein_meals_zero_to_one = /** @type {(inputs: Protein_Meals_Zero_To_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno o uno`)
};

/**
* | output |
* | --- |
* | "0–1" |
*
* @param {Protein_Meals_Zero_To_OneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protein_meals_zero_to_one = /** @type {((inputs?: Protein_Meals_Zero_To_OneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protein_Meals_Zero_To_OneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protein_meals_zero_to_one(inputs)
	if (locale === "es-419") return es_419_protein_meals_zero_to_one(inputs)
	if (locale === "pt-PT") return pt_pt2_protein_meals_zero_to_one(inputs)
	if (locale === "fr-FR") return fr_fr2_protein_meals_zero_to_one(inputs)
	if (locale === "de-DE") return de_de2_protein_meals_zero_to_one(inputs)
	if (locale === "it-IT") return it_it2_protein_meals_zero_to_one(inputs)
	return en_us2_protein_meals_zero_to_one(inputs)
});
export { protein_meals_zero_to_one as "protein_meals.zero_to_one" }